import { b64ToUtf8, convertHTMLEntities, utf8ToB64 } from '@/src/utilities/Utilities';

export function serializeRegex(regex: string): string {
  return utf8ToB64(convertHTMLEntities(regex));
}

export function deserializeRegex(serialized: string): string {
  return b64ToUtf8(serialized);
}
